/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      // if the quanity for a product is changed, update the cookie
      $( '.quoter table input' ).on( 'change', function() {
        setNewProductsCookie();
      } );

      // if the product is remove, remove the row and update the cookie
      $( '.quoter .remove-product' ).on( 'click', function() {
        $( this ).closest( 'tr' ).remove();
        setNewProductsCookie();
      } );

      // when the product table is finalized and submitted, hide the table page, show the current page, and add the products and their quanities to a hidden field in the form
      $( '.quoter .finalize-table' ).on( 'click', function() {
        $( '.quoter-page' ).toggleClass( 'is-active' );
        let productsText = '';
        $( '.quoter table input' ).each( function( inputKey, input ) {
          if ( $( input ).val() > 0 ) {
            productsText += $( input ).closest( 'tr' ).attr( 'data-name' ) + ': ' + $( input ).val() + '\n';
          }
        } );

        $( '.products-field textarea' ).val( productsText );
      } );

      // Hide the form intro when the confirmation is loaded, center the form confirmation area, and reset the cookie
      $( document ).on( 'gform_confirmation_loaded', function() {
        $( 'html,body' ).scrollTop( 0 );
        $( '.content-col' ).hide();
        $( '.form-col' ).addClass( 'mx-auto my-24' );
        window.setCookie( 'rmf_products', '' );
      } );

      function setNewProductsCookie() {
        let productsString = '';
        let productsCount = 0;
        $( '.quoter table input' ).each( function( inputKey, input ) {
          for ( let i = 0; i < $( input ).val(); i++ ) {
            productsCount++;
            if ( inputKey == 0 && i == 0 ) {
              productsString += $( input ).closest( 'tr' ).attr( 'data-id' );
            } else {
              productsString += '|' + $( input ).closest( 'tr' ).attr( 'data-id' );
            }
          }
        } );

        window.setCookie( 'rmf_products', productsString );
        if ( productsCount > 0 ) {
          $( '.request-a-quote span' ).show().text( '(' + productsCount + ')' );
          $( '.empty-products' ).addClass( 'hidden' );
          $( 'table' ).removeClass( 'hidden' );
        } else {
          $( '.request-a-quote span' ).hide().text( '(0)' );
          $( 'table' ).addClass( 'hidden' );
          $( '.empty-products' ).removeClass( 'hidden' );
        }
      }
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'quoter', COMPONENT );
} )( app );
